(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const slides = document.querySelectorAll(".swiper-slide");
  const swiperContainer = document.querySelector(".blog-slider");
  let activeFilters = new Set(); // Store selected filters

  // Initialize Swiper with Grid Layout
  let swiper = new Swiper(swiperContainer, {
    slidesPerView: 3,
    spaceBetween: 20,
    grid: { rows: 2, fill: "row" },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      320: { slidesPerView: 2, grid: { rows: 2 } },
      768: { slidesPerView: 2, grid: { rows: 2 } },
      1024: { slidesPerView: 3, grid: { rows: 2 } },
    },
  });

  // Function to update the displayed slides based on active filters
  function updateSlides() {
    swiper.removeAllSlides(); // Clear all slides from Swiper

    slides.forEach((slide) => {
      let slideTags = slide.dataset.tags ? slide.dataset.tags.split(",") : [];

      // Check if at least one tag from activeFilters matches the slide's tags
      let matchesFilter = [...activeFilters].some((filterTag) =>
        slideTags.includes(filterTag)
      );

      if (activeFilters.size === 0 || matchesFilter) {
        swiper.appendSlide(slide.outerHTML);
      }
    });

    swiper.update(); // Recalculate Swiper
  }

  // Click event for filter buttons
     filterButtons.forEach((button) => {
      button.addEventListener("click", function () {
        let filterValue = this.getAttribute("data-filter");
    
        // Remove active class from all buttons and clear active filters
        document.querySelectorAll(".filter-btn").forEach((btn) => btn.classList.remove("active"));
        activeFilters.clear();
    
        // If "all" is clicked, reset filters
        if (filterValue === "all") {
          activeFilters.clear();
        } else {
          activeFilters.add(filterValue); // Set only the selected filter
          this.classList.add("active");
        }
    
        updateSlides();
      });
    });
    
    // Click event for remove (X) buttons inside filter buttons
    document.addEventListener("click", function (event) {
      if (event.target.classList.contains("remove")) {
        let parentButton = event.target.closest(".filter-btn");
        let filterValue = parentButton.getAttribute("data-filter");
    
        activeFilters.delete(filterValue);
        parentButton.classList.remove("active");
    
        // Reset to "all" if no filters are active
        if (activeFilters.size === 0) {
          document.querySelector('.filter-btn[data-filter="all"]').classList.add("active");
        }
    
        updateSlides();
      }
    });

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
